import { handleEvent } from "@/ui-sdk/components/track/util";
import { poll } from "../utils";

function waitForProductData(productHandle: string): Promise<void> {
  return poll({
    checkFunction: async () => {
      const product = await window.helium.datastore.getProduct({
        id: productHandle,
      });
      return product && product.details;
    },
    errorMessage: "Timeout waiting for product data",
  });
}

const handleProductItem = {
  renderedSimilarSections: new Set<string>(),

  addEvent: (element: HTMLElement) => {
    const productHandle = element.getAttribute("data-helium-product-handle");
    if (!productHandle) return;

    const handleProductInteraction = () => {
      //window.helium.sessionInfo.updateInfo({        "last-pdp-viewed": productHandle,});
    };
    element.addEventListener("click", handleProductInteraction);
  },

  monitorLastViewedProduct: async () => {
    const sessionInfo = window.helium.sessionInfo?.getInfo();
    const lastViewedHandle = sessionInfo?.["last-pdp-viewed"];

    if (
      !lastViewedHandle ||
      handleProductItem.renderedSimilarSections.has(lastViewedHandle)
    ) {
      return;
    }

    try {
      await waitForProductData(lastViewedHandle);

      const [product, similarIds] = await Promise.all([
        window.helium.datastore.getProduct({ id: lastViewedHandle }),
        window.helium.datastore.getSimilar({ id: lastViewedHandle }),
      ]);

      if (!similarIds || similarIds.length === 0) {
        handleProductItem.renderedSimilarSections.add(lastViewedHandle);
        return;
      }

      const similarProducts = await Promise.all(
        similarIds.map(async (id: string) => {
          const product = await window.helium.datastore.getProduct({ id });
          return product.details;
        }),
      );

      if (similarProducts.length === 0) {
        handleProductItem.renderedSimilarSections.add(lastViewedHandle);
        return;
      }

      const existingSection = document.querySelector(
        `[data-similar-for="${lastViewedHandle}"]`,
      );

      if (existingSection) {
        handleProductItem.renderedSimilarSections.add(lastViewedHandle);
        return;
      }

      const productElement = document.querySelector(
        `[data-helium-product-handle="${lastViewedHandle}"]`,
      );

      if (productElement) {
        try {
          const element = productElement;

          if (element) {
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                handleEvent({
                  name: "because-viewed",
                  properties: { category: "" },
                });
              }
            });
            observerRef.observe(element);
          }
        } catch (e) {
          console.log("Error rendering inline block", e);
        }
        const sectionWrapper = document.createElement("div");
        sectionWrapper.setAttribute("data-similar-for", lastViewedHandle);
        sectionWrapper.style.gridColumn = "1 / -1";
        sectionWrapper.className =
          "relative bg-black text-white w-screen left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] pt-6 px-2.5";

        const productsContainer = document.createElement("div");
        sectionWrapper.appendChild(productsContainer);

        if (productElement.parentNode) {
          productElement.parentNode.insertBefore(
            sectionWrapper,
            productElement.nextSibling,
          );

          await window.helium.ui.renderInlineBlock(
            productsContainer,
            similarProducts as any,
            `Because you viewed ${product?.details?.title}`,
            "secondary",
          );

          handleProductItem.renderedSimilarSections.add(lastViewedHandle);
        }
      }
    } catch (error) {
      console.error("Error fetching similar products:", error);
      document
        .querySelectorAll("[data-similar-for]")
        .forEach((el) => el.remove());
    }
  },
};

export default handleProductItem;
